import { FC, useState } from 'react';
import { Form } from 'antd';

import { ModalComponent } from 'componets/common';
import { FormItem, SubmitButton, TextField } from 'componets/form';

import { createFilter, getFilters } from 'features/primaryMarket/actions';

import { Rules } from 'utils/constants';
import Utils from 'utils/utils';

import { FieldData, IFilterValues, ModalProps } from 'models';

import { useAppDispatch, useAppSelector, useTranslate } from 'hooks';

import { selectGlobals } from 'selectors';

import styles from './index.module.scss';

interface PrimaryMarketCreateFilterProps extends ModalProps {
	values: IFilterValues;
}
export const PrimaryMarketCreateFilter: FC<PrimaryMarketCreateFilterProps> = ({
	isOpen,
	onClose,
	values,
}) => {
	const [form] = Form.useForm();

	const dispatch = useAppDispatch();

	const savedFilters = useAppSelector((state) => state.primaryMarket.filters);
	const globals = useAppSelector(selectGlobals);

	const [fields, setFields] = useState<FieldData[]>([]);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const { cancelText, filterNameText, saveText, errorTenFilterText } = useTranslate([
		'cancelText',
		'filterNameText',
		'saveText',
		'errorTenFilterText',
	]);

	const onCloseModal = () => {
		setFields([{ name: ['title'], value: '' }]);

		onClose();
	};

	const onFinish = (data: { title: string }) => {
		if (savedFilters.length >= 10) {
			setFields([{ name: ['title'], errors: [errorTenFilterText] }]);
			return;
		}

		const dataValues = {
			title: data.title,
			criteria: {
				countryIds: values.country,
				minInterestRate: values['interestRate[from]'],
				maxInterestRate: values['interestRate[to]'],
				hideInvested: values.excludeMyInvestment,
				minLtv: values["ltv[from]"],
				maxLtv: values["ltv[to]"],
				riskLvl: values.riskLvl,
				loanTermId: globals.loanTypes
					.filter((item) => values.type?.indexOf(item.type) !== -1)
					.map((item) => item.id),
			},
		};

		setIsSubmitting(true);

		dispatch(createFilter(dataValues))
			.unwrap()
			.then(() => {
				dispatch(getFilters());

				onCloseModal();
			})
			.catch(({ e }) => {
				Utils.injectFormErrors(fields, e, setFields);
			})
			.finally(() => {
				setIsSubmitting(false);
			});
	};

	return (
		<ModalComponent
			isOpen={isOpen}
			onClose={onCloseModal}
			title={filterNameText}
			className={styles.modal}
		>
			<div className="modal-content">
				<Form onFinish={onFinish} onFieldsChange={setFields} fields={fields} form={form}>
					<FormItem name="title" rules={[Rules.REQUIRED, Rules.MAX_LENGTH('title', 47)]}>
						<TextField label={filterNameText} />
					</FormItem>
					<div className="modal-footer">
						<SubmitButton
							text={saveText}
							classNameWrapper={styles.submitWrapper}
							loading={isSubmitting}
						/>
						<div role="button" onClick={onCloseModal} className="ant-btn white-btn">
							{cancelText}
						</div>
					</div>
				</Form>
			</div>
		</ModalComponent>
	);
};
